import React from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";

import TimeInput from "../Component/TimeInput";
import RoundAndRepsInput from "../Component/RoundAndRepsInput";

export default function SubmitBox(props) {
  const {
    data,
    isSubmit,
    wodSubTitle,

    onChangeIsSuccess,
    onChangeMin,
    onChangeSec,
    onChangeRound,
    onChangeReps,
    onChangeCustomValue,

    onChangeTieBreakIsSuccess,
    onChangeTieBreakMin,
    onChangeTieBreakSec,
    onChangeTieBreakRound,
    onChangeTieBreakReps,
    onChangeTieBreakCustomValue,

    scoreRules,
    scoreSheets,
  } = props;

  const { t } = useTranslation();

  const fontFamily = 'NotoSansKR-Regular';
  const fontSize = 12;
  const fontColor = '#FFFFFF'

  return (
    <TopLevelWrapper>
      <ViewBox>
        <ScoreRulesWrapper>
          <TitleTextWrapper style={{ marginBottom: '10px' }}>
            <Circle />
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>점수 기록</Text>
          </TitleTextWrapper>
          {
            data.tag === 'ForTime' &&
            <ComponentWrapper>
              {
                data.isUseTimeCap &&
                <SuccessButtonWrapper>
                  <SuccessButton
                    isClicked={data.isSuccess}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('타임캡 안에 성공')}</Text>
                  </SuccessButton>
                  <FailedButton
                    isClicked={!data.isSuccess}>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('타임캡 터치')}</Text>
                  </FailedButton>
                </SuccessButtonWrapper>
              }
              {
                data.isUseTimeCap &&
                <TotalInputWrapper style={{ marginTop: '8px' }}>
                  {
                    data.isSuccess ?
                      <TotalInputWrapper>
                        <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('기록된 시간을 알려주세요')}</Text>
                        <TotalTimeInputWrapper>
                          <TimeInputWrapper>
                            <TimeInput
                              value={data.min}
                              setValue={onChangeMin}
                              unit='MIN'
                              isEdit={false} />
                          </TimeInputWrapper>
                          <TimeInputWrapper>
                            <TimeInput
                              value={data.sec}
                              setValue={onChangeSec}
                              unit='SEC'
                              isEdit={false} />
                          </TimeInputWrapper>
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                      :
                      <TotalInputWrapper>
                        <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('얼마나 많은 라운드, 랩 수를 했나요?')}</Text>
                        <TotalTimeInputWrapper>
                          <TimeInputWrapper>
                            <RoundAndRepsInput
                              value={data.round}
                              setValue={onChangeRound}
                              unit='R'
                              isEdit={false} />
                          </TimeInputWrapper>
                          <TimeInputWrapper>
                            <RoundAndRepsInput
                              value={data.reps}
                              setValue={onChangeReps}
                              unit='REPS'
                              isEdit={false} />
                          </TimeInputWrapper>
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                  }
                </TotalInputWrapper>
              }
              {
                !data.isUseTimeCap &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('기록된 시간을 알려주세요')}</Text>
                  <TotalTimeInputWrapper>
                    <TimeInputWrapper>
                      <TimeInput
                        value={data.min}
                        setValue={onChangeMin}
                        unit='MIN'
                        isEdit={false} />
                    </TimeInputWrapper>
                    <TimeInputWrapper>
                      <TimeInput
                        value={data.sec}
                        setValue={onChangeSec}
                        unit='SEC'
                        isEdit={false} />
                    </TimeInputWrapper>
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
            </ComponentWrapper>
          }
          {
            data.tag === 'AMRAP' &&
            <ComponentWrapper>
              <TotalInputWrapper>
                <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('얼마나 많은 라운드, 랩 수를 했나요?')}</Text>
                <TotalTimeInputWrapper>
                  <TimeInputWrapper>
                    <RoundAndRepsInput
                      value={data.round}
                      setValue={onChangeRound}
                      unit='R'
                      isEdit={false} />
                  </TimeInputWrapper>
                  <TimeInputWrapper>
                    <RoundAndRepsInput
                      value={data.reps}
                      setValue={onChangeReps}
                      unit='REPS'
                      isEdit={false} />
                  </TimeInputWrapper>
                </TotalTimeInputWrapper>
              </TotalInputWrapper>
            </ComponentWrapper>
          }
          {
            data.tag === 'Custom' &&
            <ComponentWrapper>
              {
                data.scoreKeyword === 'Not Scored' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText}</Text>
                  <SuccessButtonWrapper>
                    <SuccessButton
                      isClicked={data.isSuccess}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF'>{t('완료')}</Text>
                    </SuccessButton>
                    <FailedButton
                      isClicked={!data.isSuccess}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF'>{t('미완료')}</Text>
                    </FailedButton>
                  </SuccessButtonWrapper>
                </TotalInputWrapper>
              }
              {
                data.scoreKeyword === 'Time' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText}</Text>
                  <TotalTimeInputWrapper>
                    <TimeInputWrapper>
                      <TimeInput
                        value={data.min}
                        setValue={onChangeMin}
                        unit='MIN'
                        isEdit={false} />
                    </TimeInputWrapper>
                    <TimeInputWrapper>
                      <TimeInput
                        value={data.sec}
                        setValue={onChangeSec}
                        unit='SEC'
                        isEdit={false} />
                    </TimeInputWrapper>
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
              {
                data.scoreKeyword === 'Reps' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText}</Text>
                  <TotalTimeInputWrapper>
                    <RoundAndRepsInput
                      value={data.reps}
                      setValue={onChangeReps}
                      unit='REPS'
                      isEdit={false} />
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
              {
                data.scoreKeyword === 'Rounds + Reps' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText + '123'}</Text>
                  <TotalTimeInputWrapper>
                    <TimeInputWrapper>
                      <RoundAndRepsInput
                        value={data.round}
                        setValue={onChangeRound}
                        unit='R'
                        isEdit={false} />
                    </TimeInputWrapper>
                    <TimeInputWrapper>
                      <RoundAndRepsInput
                        value={data.reps}
                        setValue={onChangeReps}
                        unit='REPS'
                        isEdit={false} />
                    </TimeInputWrapper>
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
              {
                data.scoreKeyword === 'Distance' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText}</Text>
                  <TotalTimeInputWrapper>
                    <RoundAndRepsInput
                      value={data.customValue}
                      setValue={onChangeCustomValue}
                      unit='m'
                      isEdit={false} />
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
              {
                data.scoreKeyword === 'Weight' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText}</Text>
                  <TotalTimeInputWrapper>
                    <RoundAndRepsInput
                      value={data.customValue}
                      setValue={onChangeCustomValue}
                      unit='lbs'
                      isEdit={false} />
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
              {
                data.scoreKeyword === 'Point' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText}</Text>
                  <TotalTimeInputWrapper>
                    <RoundAndRepsInput
                      value={data.customValue}
                      setValue={onChangeCustomValue}
                      unit='Point'
                      isEdit={false} />
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
              {
                data.scoreKeyword === 'Peek Watt' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText}</Text>
                  <TotalTimeInputWrapper>
                    <RoundAndRepsInput
                      value={data.customValue}
                      setValue={onChangeCustomValue}
                      unit='Peek Watt'
                      isEdit={false} />
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
              {
                data.scoreKeyword === 'Max Speed' &&
                <TotalInputWrapper>
                  <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.customText}</Text>
                  <TotalTimeInputWrapper>
                    <RoundAndRepsInput
                      value={data.customValue}
                      setValue={onChangeCustomValue}
                      unit='Max Speed'
                      isEdit={false} />
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              }
            </ComponentWrapper>
          }

          {/* 타이브레이크 */}

          {
            data.isUseTieBreak &&
            <TieBreakScoreRulesWrapper>
              <ComponentWrapper style={{ marginTop: '30px', marginBottom: '10px' }}>
                <TitleTextWrapper>
                  <Circle />
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>타이 브레이크</Text>
                </TitleTextWrapper>
              </ComponentWrapper>
              {
                data.tieBreakTag === 'ForTime' &&
                <ComponentWrapper>
                  {
                    data.tieBreakIsUseTimeCap &&
                    <SuccessButtonWrapper>
                      <SuccessButton
                        isClicked={data.tieBreakIsSuccess}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('타임캡 안에 성공')}</Text>
                      </SuccessButton>
                      <FailedButton
                        isClicked={!data.tieBreakIsSuccess}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('타임캡 터치')}</Text>
                      </FailedButton>
                    </SuccessButtonWrapper>
                  }
                  {
                    data.tieBreakIsUseTimeCap &&
                    <TotalInputWrapper style={{ marginTop: '8px' }}>
                      {
                        data.tieBreakIsSuccess ?
                          <TotalInputWrapper>
                            <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('기록된 시간을 알려주세요')}</Text>
                            <TotalTimeInputWrapper>
                              <TimeInputWrapper>
                                <TimeInput
                                  value={data.tieBreakMin}
                                  setValue={onChangeTieBreakMin}
                                  unit='MIN'
                                  isEdit={false} />
                              </TimeInputWrapper>
                              <TimeInputWrapper>
                                <TimeInput
                                  value={data.tieBreakSec}
                                  setValue={onChangeTieBreakSec}
                                  unit='SEC'
                                  isEdit={false} />
                              </TimeInputWrapper>
                            </TotalTimeInputWrapper>
                          </TotalInputWrapper>
                          :
                          <TotalInputWrapper>
                            <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('얼마나 많은 라운드, 랩 수를 했나요?')}</Text>
                            <TotalTimeInputWrapper>
                              <TimeInputWrapper>
                                <RoundAndRepsInput
                                  value={data.tieBreakRound}
                                  setValue={onChangeTieBreakRound}
                                  unit='R'
                                  isEdit={false} />
                              </TimeInputWrapper>
                              <TimeInputWrapper>
                                <RoundAndRepsInput
                                  value={data.tieBreakReps}
                                  setValue={onChangeTieBreakReps}
                                  unit='REPS'
                                  isEdit={false} />
                              </TimeInputWrapper>
                            </TotalTimeInputWrapper>
                          </TotalInputWrapper>
                      }
                    </TotalInputWrapper>
                  }
                  {
                    !data.tieBreakIsUseTimeCap &&
                    <TotalInputWrapper>
                      <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('기록된 시간을 알려주세요')}</Text>
                      <TotalTimeInputWrapper>
                        <TimeInputWrapper>
                          <TimeInput
                            value={data.tieBreakMin}
                            setValue={onChangeTieBreakMin}
                            unit='MIN'
                            isEdit={false} />
                        </TimeInputWrapper>
                        <TimeInputWrapper>
                          <TimeInput
                            value={data.tieBreakSec}
                            setValue={onChangeTieBreakSec}
                            unit='SEC'
                            isEdit={false} />
                        </TimeInputWrapper>
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                </ComponentWrapper>
              }
              {
                data.tieBreakTag === 'AMRAP' &&
                <ComponentWrapper>
                  <TotalInputWrapper>
                    <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('얼마나 많은 라운드, 랩 수를 했나요?')}</Text>
                    <TotalTimeInputWrapper>
                      <TimeInputWrapper>
                        <RoundAndRepsInput
                          value={data.tieBreakRound}
                          setValue={onChangeTieBreakRound}
                          unit='R'
                          isEdit={false} />
                      </TimeInputWrapper>
                      <TimeInputWrapper>
                        <RoundAndRepsInput
                          value={data.tieBreakReps}
                          setValue={onChangeTieBreakReps}
                          unit='REPS'
                          isEdit={false} />
                      </TimeInputWrapper>
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                </ComponentWrapper>
              }
              {
                data.tieBreakTag === 'Custom' &&
                <ComponentWrapper>
                  {
                    data.tieBreakScoreKeyword === 'Not Scored' &&
                    <TotalInputWrapper>
                      <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <SuccessButtonWrapper>
                        <SuccessButton
                          isClicked={data.tieBreakIsSuccess}>
                          <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('완료')}</Text>
                        </SuccessButton>
                        <FailedButton
                          isClicked={!data.tieBreakIsSuccess}>
                          <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{t('미완료')}</Text>
                        </FailedButton>
                      </SuccessButtonWrapper>
                    </TotalInputWrapper>
                  }
                  {
                    data.tieBreakScoreKeyword === 'Time' &&
                    <TotalInputWrapper>
                      <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <TotalTimeInputWrapper>
                        <TimeInputWrapper>
                          <TimeInput
                            value={data.tieBreakMin}
                            setValue={onChangeTieBreakMin}
                            unit='MIN'
                            isEdit={false} />
                        </TimeInputWrapper>
                        <TimeInputWrapper>
                          <TimeInput
                            value={data.tieBreakSec}
                            setValue={onChangeTieBreakSec}
                            unit='SEC'
                            isEdit={false} />
                        </TimeInputWrapper>
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                  {
                    data.tieBreakScoreKeyword === 'Reps' &&
                    <TotalInputWrapper>
                      <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <TotalTimeInputWrapper>
                        <RoundAndRepsInput
                          value={data.tieBreakReps}
                          setValue={onChangeTieBreakReps}
                          unit='REPS'
                          isEdit={false} />
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                  {
                    data.tieBreakScoreKeyword === 'Rounds + Reps' &&
                    <TotalInputWrapper>
                      <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <TotalTimeInputWrapper>
                        <TimeInputWrapper>
                          <RoundAndRepsInput
                            value={data.tieBreakRound}
                            setValue={onChangeTieBreakRound}
                            unit='R'
                            isEdit={false} />
                        </TimeInputWrapper>
                        <TimeInputWrapper>
                          <RoundAndRepsInput
                            value={data.tieBreakReps}
                            setValue={onChangeTieBreakReps}
                            unit='REPS'
                            isEdit={false} />
                        </TimeInputWrapper>
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                  {
                    data.tieBreakScoreKeyword === 'Distance' &&
                    <TotalInputWrapper>
                      <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <TotalTimeInputWrapper>
                        <RoundAndRepsInput
                          value={data.tieBreakCustomValue}
                          setValue={onChangeTieBreakCustomValue}
                          unit='m'
                          isEdit={false} />
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                  {
                    data.tieBreakScoreKeyword === 'Weight' &&
                    <TotalInputWrapper>
                      <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <TotalTimeInputWrapper>
                        <RoundAndRepsInput
                          value={data.tieBreakCustomValue}
                          setValue={onChangeTieBreakCustomValue}
                          unit='lbs'
                          isEdit={false} />
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                  {
                    data.tieBreakScoreKeyword === 'Point' &&
                    <TotalInputWrapper>
                      <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <TotalTimeInputWrapper>
                        <RoundAndRepsInput
                          value={data.tieBreakCustomValue}
                          setValue={onChangeTieBreakCustomValue}
                          unit='Point'
                          isEdit={false} />
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                  {
                    data.tieBreakScoreKeyword === 'Peek Watt' &&
                    <TotalInputWrapper>
                      <Text fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <TotalTimeInputWrapper>
                        <RoundAndRepsInput
                          value={data.tieBreakCustomValue}
                          setValue={onChangeTieBreakCustomValue}
                          unit='Peek Watt'
                          isEdit={false} />
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                  {
                    data.tieBreakScoreKeyword === 'Max Speed' &&
                    <TotalInputWrapper>
                      <Text  fontFamily={fontFamily} fontSize={fontSize} color={fontColor} cursor='default'>{data.tieBreakCustomText}</Text>
                      <TotalTimeInputWrapper>
                        <RoundAndRepsInput
                          value={data.tieBreakCustomValue}
                          setValue={onChangeTieBreakCustomValue}
                          unit='Max Speed'
                          isEdit={false} />
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  }
                </ComponentWrapper>
              }
            </TieBreakScoreRulesWrapper>
          }

          {/* 타이브레이크 */}

        </ScoreRulesWrapper>
      </ViewBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 10px 15px 20px 15px;
  // margin-top: 10px;

  width: calc(100% - 30px);

  // border-radius: 10px;
  // background-color: #17171B;
`;

const ScoreRulesWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 100%;
`;

const TieBreakScoreRulesWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 100%;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const SuccessButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;
`;

const SuccessButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 48%;
  height: 32px;

  border-radius: 32px;
  background-color: ${props => props.isClicked ? '#6DD49E' : '#D9D9D9'};
  
  transition: all 0.3s ease-in-out;
`;

const FailedButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 48%;
  height: 32px;

  border-radius: 32px;
  background-color: ${props => props.isClicked ? '#FF3131' : '#D9D9D9'};
  
  transition: all 0.3s ease-in-out;
`;

const TotalInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const TotalTimeInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 8px;

  width: 100%;
`;

const TimeInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 48%;
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const Circle = styled.div`
  width: 10px;
  height: 10px;

  border-radius: 10px;
  background-color: #6DD49E;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  text-overflow: ellipsis;

  :hover {
    cursor: default;
  }
`;


